import React, { createContext, useState, useEffect, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export const ProductContext = createContext();

const DEFAULT_PRODUCT_ID = '105001';

const ProductProvider = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const queryParams = new URLSearchParams(location.search);
  const initialProductId = queryParams.get('p_id') || DEFAULT_PRODUCT_ID;

  const [selectedProductId, setSelectedProductId] = useState(initialProductId);
  const [selectedLanguage, setSelectedLanguage] = useState('en');
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadProducts = async () => {
      setLoading(true);
      try {
        const response = await fetch(`/Products_${selectedLanguage}.json`);
        if (!response.ok) throw new Error('Network response was not ok');
        const productData = await response.json();
        const loadedProducts = Array.isArray(productData.products)
          ? productData.products
          : Object.values(productData.products);
        setProducts(loadedProducts);
      } catch (error) {
        console.error('Failed to load product data:', error);
        setProducts([]);
      } finally {
        setLoading(false);
      }
    };
    loadProducts();
  }, [selectedLanguage]);

  const selectedProduct = useMemo(() => {
    if (!Array.isArray(products)) return null;
    return products.find(
      (product) => String(product.p_Id) === String(selectedProductId)
    );
  }, [products, selectedProductId]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get('p_id') !== selectedProductId) {
      params.set('p_id', selectedProductId);
      navigate({ search: params.toString() }, { replace: true });
    }
  }, [selectedProductId, navigate, location.search]);

  const contextValue = {
    selectedProductId,
    setSelectedProductId,
    selectedLanguage,
    setSelectedLanguage,
    selectedProduct,
    products,
    loading,
  };

  return (
    <ProductContext.Provider value={contextValue}>
      {children}
    </ProductContext.Provider>
  );
};

export default ProductProvider;
